import React, { useContext, useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { MdDashboard, MdFolder, MdCheckCircle, MdEvent, MdPeople, MdLogout, MdMenu, MdMenuOpen, MdPerson, MdCardMembership, MdEmail, MdCreditCard, MdWeb } from 'react-icons/md';
import './Sidebar.css';

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useContext(AuthContext);
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    // Update CSS variable based on screen size and collapsed state
    const updateSidebarWidth = () => {
      const isDesktop = window.innerWidth >= 1025;
      if (isDesktop) {
        document.documentElement.style.setProperty(
          '--sidebar-width',
          isCollapsed ? '80px' : '260px'
        );
      } else {
        // Mobile: no left margin
        document.documentElement.style.setProperty('--sidebar-width', '0px');
      }
    };

    updateSidebarWidth();
    window.addEventListener('resize', updateSidebarWidth);
    
    return () => window.removeEventListener('resize', updateSidebarWidth);
  }, [isCollapsed]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuItems = [
    { path: '/', icon: <MdDashboard />, label: 'Dashboard' },
    { path: '/projects', icon: <MdFolder />, label: 'Projects' },
    { path: '/tasks', icon: <MdCheckCircle />, label: 'Tasks' },
    { path: '/events', icon: <MdEvent />, label: 'Events', adminOnly: true },
    { path: '/users', icon: <MdPeople />, label: 'Users', adminOnly: true },
    { path: '/feedback', icon: <MdEmail />, label: 'Feedback', adminOnly: true },
    { path: '/portfolio', icon: <MdWeb />, label: 'Portfolio', adminOnly: true },
    { path: '/business-card', icon: <MdCreditCard />, label: 'Business Card' },
    { path: '/idcard', icon: <MdCardMembership />, label: 'ID Card' },
    { path: '/profile', icon: <MdPerson />, label: 'Profile', userOnly: true },
    { path: '/settings', icon: <MdPerson />, label: 'Profile', adminOnly: true }
  ];

  // Filter menu items based on user role
  const visibleMenuItems = menuItems.filter(item => {
    if (item.adminOnly) {
      return user?.role === 'admin';
    }
    if (item.userOnly) {
      return user?.role !== 'admin';
    }
    return true;
  });

  return (
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <div className="logo">
          <div className="logo-text-container">
            <span className="logo-text">JIRUU</span>
            <span className="logo-text-sub">TECH</span>
          </div>
        </div>
        <button 
          className="toggle-btn" 
          onClick={() => setIsCollapsed(!isCollapsed)}
          title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {isCollapsed ? <MdMenu /> : <MdMenuOpen />}
        </button>
      </div>

      <nav className="sidebar-nav">
        {visibleMenuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </Link>
        ))}
      </nav>

      <div className="sidebar-footer">
        <button onClick={handleLogout} className="logout-btn">
          <MdLogout /> <span className="logout-text">Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
